<template>
  <div class="view box grow">
    <page-headers
      :header="'Launchpad'"
      :breadcrumbs="breadcrumbs"
      :is-border="true"
      documentation="page-integration"
      class="box"
    >
    </page-headers>
    <div class="full-width">
      <span class="material-icons float-right cursor-pointer" @click="gotoIntegrationList">close</span>
    </div>
    <div class="full-height">
      <h3 class="mb-20">Configure Public Cloud Integration</h3>
      <el-row :gutter="20">
        <el-col :span="6">
          <integration-card :icon-class="'fab fa-aws'" @card-click="gotoConfigure('aws')" />
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="cursor-pointer" style="text-align: center;">
            <span class="display-block"><i class="fab fa-microsoft" style="font-size: 5em;"></i></span>
            Connect Azure Account
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover" class="cursor-pointer" style="text-align: center;">
            <span class="display-block"><i class="fab fa-google" style="font-size: 5em;"></i></span>
            Connect Google Cloud Platform (GCP) Account
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card
            shadow="hover"
            class="cursor-pointer"
            style="text-align: center;"
            @click.native="gotoConfigure('kubernetes')"
          >
            <span class="display-block"><i class="fas fa-dharmachakra" style="font-size: 5em;"></i></span>
            Connect Kubernetes Account
          </el-card>
        </el-col>
      </el-row>

      <h3 class="mt-20 mb-20">Configure Security Product Integration</h3>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card
            shadow="hover"
            class="cursor-pointer"
            style="text-align: center;"
            @click.native="gotoConfigure('carbonblack')"
          >
            <span class="display-block"><i class="fas fa-user-shield" style="font-size: 5em;"></i></span>
            Carbon Black
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card
            shadow="hover"
            class="cursor-pointer"
            style="text-align: center;"
            @click.native="gotoConfigure('pan')"
          >
            <span class="display-block"><i class="fas fa-user-shield" style="font-size: 5em;"></i></span>
            Palo Alto Networks
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card
            shadow="hover"
            class="cursor-pointer"
            style="text-align: center;"
            @click.native="gotoConfigure('snyk')"
          >
            <span class="display-block"><i class="fas fa-user-shield" style="font-size: 5em;"></i></span>
            Snyk
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card
            shadow="hover"
            class="cursor-pointer"
            style="text-align: center;"
            @click.native="gotoConfigure('guardduty')"
          >
            <span class="display-block"><i class="fas fa-user-shield" style="font-size: 5em;"></i></span>
            Guard Duty
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card
            shadow="hover"
            class="cursor-pointer"
            style="text-align: center;"
            @click.native="gotoConfigure('trendmicro')"
          >
            <span class="display-block"><i class="fas fa-user-shield" style="font-size: 5em;"></i></span>
            Trend Micro
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import IntegrationCard from '@/components/card/integration/IntegrationCard.vue'
import PageHeaders from '@/components/layout/PageHeaders.vue'

export default {
  name: 'IntegrationConfiguration',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  data () {
    return {
      breadcrumbs: [{ title: 'Setup' }, { title: 'Launchpad', to: '/integrations' }, { title: 'Configure' }],
      activeView: '',
      prevRoute: {}
    }
  },
  methods: {
    gotoIntegrationList () {
      this.$router.push({
        name: 'integrations',
        params: this.breadcrumbs[1].to.params,
        query: this.breadcrumbs[1].to.query
      })
    },
    gotoConfigure (integrationType) {
      this.$router.push({
        name: 'integration-workflow',
        params: { integrationType: integrationType }
      })
    }
  },
  created () {
    this.activeView = this.$route.path.split('/').reverse()[0]
  },
  computed: {
    ...mapGetters([])
  },
  components: {
    PageHeaders,
    IntegrationCard
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
</style>



// WEBPACK FOOTER //
// src/views/integrations/IntegrationConfiguration.vue